module.exports = __webpack_public_path__ + "media/images/scoreBet__detailScore__markWrong--dark-5b70c1e43ab42cb115815795ebbd5a4e.png";